import React, { useState } from 'react';
import { Modal } from '../../../UiKit';
import ChatSummary from './ChatSummary';
import { MessageSquareText } from 'lucide-react';
import Button from '../../ComponentsV1/Button';

const ChatSummaryBtn = (props) => {
  const [OpenChatSummaryModal, setOpenChatSummaryModal] = useState(false);
  return (
    <>
      <Button
        onClick={() => setOpenChatSummaryModal(true)}
        size='small'
        title={
          <div className='tw-flex tw-items-center tw-gap-2 tw-leading-none tw-font-medium'>
            <div>
              <MessageSquareText size={16} strokeWidth='2' />
            </div>
            <div className='tw-text-[14px] tw-whitespace-nowrap'>
              Chat Summary
            </div>
          </div>
        }
      />
      {OpenChatSummaryModal && (
        <Modal
          padding={0}
          containerStyles={{
            margin: '16px 0 20px 0',
            padding: '0 20px',
          }}
          isVisible={OpenChatSummaryModal}
          title={
            <div className='tw-flex tw-items-center tw-gap-2 tw-text-[2rem] tw-font-medium tw-text-zinc-700'>
              <MessageSquareText className='tw-mt-1' />
              Chat Summary
            </div>
          }
          type='huge'
          minHeight='80vh'
          handleClose={() => setOpenChatSummaryModal(false)}
          component={<ChatSummary {...props} />}
        />
      )}
    </>
  );
};

export default ChatSummaryBtn;
